export default "__VITE_ASSET__Cd1M7m5$__"